import { OrderStatus } from "@white-labels/input"

/** Tint color per order status, shared by the orders list, details, and edit screens. */
export const statusColors: Record<OrderStatus, string> = {
  pending: "#f59e0b",
  confirmed: "#3b82f6",
  preparing: "#8b5cf6",
  out_for_delivery: "#6366f1",
  delivered: "#10b981",
  cancelled: "#6b7280",
  rejected: "#ef4444",
  delivery_failed: "#dc2626",
}

/** Statuses from which an order can still be edited. */
const EDITABLE_STATUSES: ReadonlySet<OrderStatus> = new Set(["pending", "confirmed", "preparing", "out_for_delivery"])

export function isOrderEditable(status: OrderStatus): boolean {
  return EDITABLE_STATUSES.has(status)
}